import {createFileRoute, redirect} from '@tanstack/react-router';

export const Route = createFileRoute('/_protected/withdrawal/')({
  validateSearch: (search) => {
    return {
      accountId: search.accountId as string | undefined,
    };
  },
  beforeLoad: ({search}) => {
    const accountId = search.accountId;
    if (accountId) {
      throw redirect({
        to: '/home/accounts/deposits/$accountId',
        params: {accountId},
      });
    }
    throw redirect({to: '/home'});
  },
});
